import { render, staticRenderFns } from "./ListFakeTeams.vue?vue&type=template&id=b2985a04"
import script from "./ListFakeTeams.vue?vue&type=script&lang=js"
export * from "./ListFakeTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports